<template>
<div class="size tw-flex tw-flex-col tw-items-center amount-requested tw-px-4 lg:tw-pt-20 lg:tw-mb-0 tw-mb-48">
    <div class="tw-flex tw-flex-col tw-items-center tw-mt-6 tw-w-full">
    <title-section 
    title="Tamaño"
    subtitle="¿Qué tamaño tiene tu vivienda?"></title-section>
    <div
        class="size-container tw-flex tw-items-center tw-mt-8"
    >
        <div class="size-container-items tw-flex tw-flex-col">
            <div class="tw-text-left tw-w-full tw-mb-4">
                <p>Tamaño</p>
                <p class="optional">Tamaño de la vivienda (m²)</p>
            </div>
            <div class="tw-flex">
                <label
                class="input-size first-input mdc-text-field mdc-text-field--outlined mdc-text-field--no-label"
                >
                <input
                    v-model="size"
                    class="mdc-text-field__input input-size"
                    type="number"
                    aria-label="Label"
                />
                <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__trailing"></span>
                </span>
                </label>
            </div>
        </div>
    </div>
    <div
        class="size-container tw-flex tw-flex-col tw-items-center tw-mt-8"
    >
        <div class="tw-flex tw-flex-col size-container-items">
            <div class="tw-text-left tw-w-full tw-mb-4">
                <p>Habitaciones</p>
                <p class="optional">Número de habitaciones</p>
            </div>
            <div class="tw-flex">
                <label
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--no-label tw-mr-4 tw-w-full"
                >
                <input
                    v-model="rooms"
                    class="mdc-text-field__input"
                    type="number"
                    aria-label="Label"
                />
                <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__trailing"></span>
                </span>
                </label>
                <img src="/img/icons/icon-least.webp" class="button-plus tw-mr-4"  :class="rooms == 0 || rooms == '' ? 'disabled' : ''" @click="rooms--"/>
                <img src="/img/icons/icon-plus.webp" class="button-plus"  @click="rooms++"/>
            </div>
        </div>
    </div>
    <div
        class="size-container tw-flex tw-flex-col tw-items-center tw-mt-8"
    >
    <div class="tw-flex tw-flex-col size-container-items">
            <div class="tw-text-left tw-w-full tw-mb-4">
                <p>Baños</p>
                <p class="optional">Número de baños</p>
            </div>
            <div class="tw-flex">
                <label
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--no-label tw-mr-4 tw-w-full"
                >
                <input
                    v-model="toilets"
                    class="mdc-text-field__input"
                    type="number"
                    aria-label="Label"
                />
                <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__trailing"></span>
                </span>
                </label>
                <img src="/img/icons/icon-least.webp" class="button-plus tw-mr-4"  :class="toilets == 0 || toilets == '' ? 'disabled' : ''" @click="toilets--"/>
                <img src="/img/icons/icon-plus.webp" class="button-plus"  @click="toilets++"/>
            </div>
        </div>
    </div>
    </div>
    <div class="fixed-button-mobile fixed-button-mobile-size  tw-mt-8">
    <button
        @click="goNextStep(size, rooms, toilets)"
        class="btn btn-primary fixed-button btn-steps tw-flex tw-items-center tw-justify-center"
        :class="{ active: size &&  rooms && toilets}"
    >
        Siguiente
    </button>
    </div>
</div>
</template>

<script>
import { MDCTextField } from "@material/textfield";
import { mapGetters, mapMutations } from "vuex";

export default {
data: () => ({
    size: "",
    rooms: "",
    toilets: ""
}),
computed: {
    ...mapGetters({
    wizard: "getWizard",
    }),
},
methods: {
    ...mapMutations(["selectSize", "selectRooms", "selectToilets"]),
    goNextStep(size, rooms, toilets){
        if(size && rooms && toilets){
            this.selectSize(size);
            this.selectRooms(rooms);
            this.selectToilets(toilets);
            this.$router.push({ name: "GroundFloor" });
        }
    }
},

mounted() {
    const textField = new MDCTextField(
    document.querySelector(".mdc-text-field")
    );
},
};
</script>
    
<style lang="scss">
@import "../../../sass/variables";
.size {
    .size-container {
        @media(max-width: $lg){
            width: 100%;
        }
        &-items {
            @media(max-width: $lg){
                width: 100%;
            }
        }
        .first-input {
            @media(max-width: $lg){
                width: 100%;
            }
        }
    }
    .btn-primary {
        margin-left: auto;
        margin-right: auto;
        height: 48px;
        border-radius: 6px;
        transition: all 0.4s ease-in-out;
        background-color: $color-grey-hover;

        &.active {
        background-color: $primary;
        }
    }
    .material-icons {
        font-size: 18px;
    }
    input {
        width: 377px;
        font-size: 16px;
        @media(max-width: $lg){
            width: 100%;
        }
    }
    .input-size {
        width: 500px;
        @media(max-width: $lg){
            width: 100%;
        }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .btn-steps {
      @media(max-width: $lg){
        left: 3%;
      }
    }
    .subtract {
        padding-bottom: 2.3rem;
    }
    .input-size {
        width: 541px;
        @media(max-width: $lg){
            width: 100%;
        }
    }
}

</style>
    